import { Buffer } from "buffer";
window.Buffer = window.Buffer || Buffer;

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { driver } from '@/plugins'

// Directives
import directives from './directives';

// import BOOTSTRAP
import 'ASSETS/scss/bootstrap/bootstrap.scss'
// import CUSTOM
import 'ASSETS/scss/custom.scss'

createApp(App)
    .use(store)
    .use(router)

// import GLOBAL COMPONENTS
import { Input, Spinner, Table, Table2, Modal, Alert, Select, DropDown, Loader, Loading, CircularProgress } from './components/index.js'


// TEMPLATES
import T_default from 'TEMPLATES/default'
import T_session from 'TEMPLATES/session'

//libs
import _Lodash from 'lodash'
import _sendRequest from '../src/libs/sendRequest'
import _informativeDate from '../src/libs/informativeDate'
import _redirect from '../src/libs/redirect'


// Create App
const app = createApp(App)

app.use(store)
app.use(router)


import VueGoogleMaps from '@fawmi/vue-google-maps'
app.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyDvCCUv6q09IKaX0a8Mr2B66izt9nSLuw0'
    },
})

import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
app.component('VueDatePicker', VueDatePicker)

//plugins
app.use(driver)


// Registrer all directives
Object.entries(directives).forEach(([name, directive]) => {
    app.directive(name, directive);
});



// templates
app.component('default', T_default)
app.component('session', T_session)
// components
app.component('ws-input', Input)
app.component('ws-modal', Modal)
app.component('ws-table', Table)
app.component('mn-table', Table2)
app.component('ws-spinner', Spinner)
app.component('ws-select', Select)
app.component('ws-alert', Alert)
app.component('ws-dropdown', DropDown)
app.component('ws-loader', Loader)
app.component('ws-loading', Loading)
app.component('ws-circular-progress', CircularProgress)

// libs
app.provide('$_', _Lodash)
app.provide('$sendRequest', _sendRequest)
app.provide('$informativeDate', _informativeDate)
app.provide('$redirect', _redirect)


app.mount('#app')
